var wishlistURL = 'https://us-central1-bi-master-project.cloudfunctions.net/ma_wishlist_au';
var wishlistItemDeleteURL = 'https://us-central1-bi-master-project.cloudfunctions.net/ma_wishlist_delete_item_au';
var wishlistItemURL = 'https://us-central1-bi-master-project.cloudfunctions.net/ma_wishlist_item_au';
var wishlistMergeURL = 'https://us-central1-bi-master-project.cloudfunctions.net/ma_wishlist_merge_au';

function setStoredObject(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function getStoredObject(key) {
  var value = localStorage.getItem(key);
  return value && JSON.parse(value);
}

/**
 * Get wishlist from API
 * @param {*} identifier 
 * @param {*} type 
 * @returns 
 */
async function getWishListAPI(identifier, type = 'id') {
  try {
    var queryData = { wishlist_id: identifier };
    if (type !== "id") {
      queryData = { email: identifier };
    }
    const result = await $.ajax({
      type: "GET",
      url: wishlistURL,
      dataType: 'json',
      data: queryData
    });

    return result;

  } catch (error) {
    return {};
  }
}

/**
 * Save wishlist
 * @param {*} identifier 
 * @param {*} type 
 * @returns 
 */
async function saveWishListAPI(data) {
  try {
    const saveWishlistData = {
      wishlist_id: data?.wishlist_id,
      items: data?.items,
      customer_email: data?.customer_email,
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistURL,
      dataType: 'json',
      data: saveWishlistData
    });

    return result;

  } catch (error) {
    return {};
  }
}

/**
 * @param {*} productData
 * @returns 
 */
async function addWishlistItemAPI(wishlistId, productId, variantId, sku) {
  try {
    const addItemData = {
      wishlist_id: wishlistId,
      product_id: productId,
      variant_id: variantId,
      sku
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistItemURL,
      dataType: 'json',
      data: addItemData
    });
    return result;
  } catch (error) {
    return {};
  }
}

/**
 * delete api
 * @param {*} productData 
 * @returns 
 */
async function deleteWishListItemAPI(wishlistId, item_ids) {
  try {
    const postData = {
      wishlist_id: wishlistId,
      items: item_ids
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistItemDeleteURL,
      dataType: 'json',
      data: postData
    });
    return result;
  } catch (error) {
    return false;
  }
}

/**

 * @param {*} productDataDelete 
 * @returns 
 */
async function deleteWishlistItem(customerEmail, variantId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      const result = wishlist?.items?.find((elm) => elm.variant_id === variantId);
      if (result) {
        deleteWishlistItemList.push(result?.item_id)
        const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
        if (response?.wishlist_id) {
          const updatedTime = new Date();
          const updatedTimeMillisec = updatedTime.getTime();
          const wishlistData = {
            wishlist: response,
            customer_email: response?.customer_email || '',
            updatedAt: updatedTimeMillisec
          }
          setStoredObject('ma_wishlist', wishlistData);
        }
        return response;
      } else {
        return {};
      }
    }
  } catch (error) {
    return {};
  }
}

/**

 * @param {*} productDataDelete 
 * @returns 
 */
async function deleteWishlistItemByProductId(customerEmail, productId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      wishlist?.items.map(wi => {
        if (wi?.product_id === '' + productId) {
          deleteWishlistItemList.push(wi?.item_id)
        }
      });

      const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
      if (response?.wishlist_id) {
        const updatedTime = new Date();
        const updatedTimeMillisec = updatedTime.getTime();
        const wishlistData = {
          wishlist: response,
          customer_email: response?.customer_email || '',
          updatedAt: updatedTimeMillisec
        }
        setStoredObject('ma_wishlist', wishlistData);
      }
      return response;
    }
  } catch (error) {
    return {};
  }
}

async function deleteWishlistItemByItemId(customerEmail, itemId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const response = await deleteWishListItemAPI(wishlist?.wishlist_id, [itemId]);
      if (response?.wishlist_id) {
        const updatedTime = new Date();
        const updatedTimeMillisec = updatedTime.getTime();
        const wishlistData = {
          wishlist: response,
          customer_email: response?.customer_email || '',
          updatedAt: updatedTimeMillisec
        }
        setStoredObject('ma_wishlist', wishlistData);
      }
      return response;
    }
  } catch (error) {
    return {};
  }
}

/** Delete Item by SKu
 * 
 * @param {*} customerEmail 
 * @param {*} sku 
 * @returns 
 */
async function deleteWishlistItemBySku(customerEmail, sku) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      const result = wishlist?.items?.find((elm) => elm?.sku === sku);
      if (result) {
        deleteWishlistItemList.push(result?.item_id)
        const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
        if (response?.wishlist_id) {
          const updatedTime = new Date();
          const updatedTimeMillisec = updatedTime.getTime();
          const wishlistData = {
            wishlist: response,
            customer_email: response?.customer_email || '',
            updatedAt: updatedTimeMillisec
          }
          setStoredObject('ma_wishlist', wishlistData);
        }
        return response;
      } else {
        return {};
      }
    }
  } catch (error) {
    console.log(error);
    return {};
  }
}

/**
 * 
 * @param {*} productData 
 */
async function addProductToWishList(customerEmail, data) {
  const wishlist = await getWishlist(customerEmail);
  const response = await addWishlistItemAPI(wishlist?.wishlist_id, data?.product_id, data?.variant_id)
  if (response?.wishlist_id) {
    const updatedTime = new Date();
    const updatedTimeMillisec = updatedTime.getTime();
    const wishlistData = {
      wishlist: response,
      customer_email: customerEmail,
      updatedAt: updatedTimeMillisec
    }
    setStoredObject('ma_wishlist', wishlistData);
  }
  return response;
}

/**
 * Add Product to wishlist by SKU
 * @param {*} customerEmail 
 * @param {*} sku 
 * @returns 
 */
async function addProductToWishListBySku(customerEmail, sku) {
  const wishlist = await getWishlist(customerEmail);
  const response = await addWishlistItemAPI(wishlist?.wishlist_id, undefined, undefined, sku)
  if (response?.wishlist_id) {
    const updatedTime = new Date();
    const updatedTimeMillisec = updatedTime.getTime();
    const wishlistData = {
      wishlist: response,
      customer_email: customerEmail,
      updatedAt: updatedTimeMillisec
    }
    setStoredObject('ma_wishlist', wishlistData);
  }
  return response;
}

async function getWishlist(customerEmail = '') {
  if (customerEmail !== '') {
    const localWishlist = getStoredObject('ma_wishlist');
    if (!localWishlist) {
      const currentTime = new Date();
      const currentTimeInMili = currentTime.getTime();
      let result = await getWishListAPI(customerEmail, 'email');
      if (!result?.wishlist_id) {
        result = await saveWishListAPI({ customer_email: customerEmail });
      }
      const wishlistData = {
        wishlist: result?.wishlist_id ? result : {},
        customer_email: customerEmail,
        updatedAt: currentTimeInMili
      }
      setStoredObject('ma_wishlist', wishlistData);
      return result;
    } else {
      if (localWishlist?.customer_email) {
        const currentTime = new Date();
        const currentTimeInMili = currentTime.getTime();
        var resultInMinutes = Math.round((currentTimeInMili - localWishlist?.updatedAt) / 60000);

        if (resultInMinutes < 2) {
          return localWishlist?.wishlist;
        } else {
          const result = await getWishListAPI(localWishlist?.wishlist?.wishlist_id);
          if (result?.wishlist_id) {
            const wishlistData = {
              wishlist: result,
              customer_email: customerEmail,
              updatedAt: currentTimeInMili
            }
            setStoredObject('ma_wishlist', wishlistData);
            return result;
          } else {
            let newWishlist = await saveWishListAPI(localWishlist?.wishlist);
            const wishlistData = {
              wishlist: newWishlist?.wishlist_id ? newWishlist : {},
              customer_email: customerEmail,
              updatedAt: currentTimeInMili
            }
            setStoredObject('ma_wishlist', wishlistData);
            return newWishlist;
          }
        }
      } else {
        const result = await getWishListAPI(localWishlist?.wishlist?.wishlist_id);
        let updatedResult;
        if (result?.wishlist_id) {
          updatedResult = await mergeWishlist(localWishlist?.wishlist?.wishlist_id, customerEmail);
          return updatedResult;
        } else {
          const currentTime = new Date();
          const currentTimeInMili = currentTime.getTime();
          const wishlistSaveData = localWishlist?.wishlist;
          wishlistSaveData['customer_email'] = customerEmail;
          const newWishlist = await saveWishListAPI(wishlistSaveData);
          const wishlistData = {
            wishlist: newWishlist?.wishlist_id ? newWishlist : {},
            customer_email: customerEmail,
            updatedAt: currentTimeInMili
          }
          setStoredObject('ma_wishlist', wishlistData);
          return newWishlist;
        }
      }
    }
  } else {
    const localWishlist = getStoredObject('ma_wishlist');
    if (!localWishlist) {
      return {}
    } else {
      return localWishlist?.wishlist;
    }
  }
}

async function mergeWishlist(wishlist_id, customerEmail) {
  try {
    const postData = {
      "wishlist_id": wishlist_id,
      "email": customerEmail
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistMergeURL,
      dataType: 'json',
      data: postData
    });

    if (result?.wishlist_id) {
      const updatedTime = new Date();
      const updatedTimeMillisec = updatedTime.getTime();
      const wishlistData = {
        wishlist: result,
        customer_email: customerEmail,
        updatedAt: updatedTimeMillisec
      }
      setStoredObject('ma_wishlist', wishlistData);
      return result;
    } else {
      console.log(`Error merging the wishlist`);
      return {};
    }
  } catch (error) {
    return {};
  }
}

/**
 * Push sku to Google tag manager
 * @param {*} sku
 */
async function sendToGTM(sku){
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_wishlist_from_roomvo",
    ecommerce: {
      currency: "AUD",
      items: [
        {
          item_id: sku
        }
      ]
    }
  });
}

// to call when logout
async function clearStorage() {
  setStoredObject('ma_wishlist', null);
}